import {
  NavigationElement,
  UserModel,
  LoginService,
  NavigationChangeService,
  NavigationService,
} from "@edtell-common";
import { Component, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  Data,
  NavigationEnd,
  PRIMARY_OUTLET,
  Router,
  RouterModule,
} from "@angular/router";
import * as _ from "lodash";
import { filter, map } from "rxjs/operators";

declare const google;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  navData: NavigationElement[];

  userName = "";
  userPicture = "";

  show = false;

  currentUser: UserModel;

  ready = false;

  constructor(
    private loginService: LoginService,
    private navigationChanged: NavigationChangeService,
    private navigationService: NavigationService,
  ) {
    this.navigationChanged.updateNav.subscribe((navData) => {
      this.navData = navData;
    });

    this.navigationChanged.navigationChanged.subscribe((e) => {
      this.reloadNavigation();
    });

    this.reloadNavigation();
  }

  // This sorts the navigation recursively to all the children first by order and then by name.
  sortNavigation(navMap) {
    if (navMap.length > 1) {
      navMap.sort((a, b) => {
        if (a.order === b.order) {
          // sort alphabetically if elements have the same sort order
          if (a.name != "divider" && b.name != "divider") {
            if (a.name > b.name) {
              return 1;
            } else {
              return -1;
            }
          } else {
            return 1;
          }
        } else if (a.order > b.order) {
          return 1;
        } else if (a.order < b.order) {
          return -1;
        }
      });
      navMap.forEach((item) => {
        if (!_.isEmpty(item.children)) {
          this.sortNavigation(item.children);
        }
      });
    }
  }

  reloadNavigation() {
    this.navigationService.getNavigationBySegmentId(1).subscribe((resp) => {
      localStorage.removeItem("nav");

      const values = resp;
      this.sortNavigation(values);

      this.navData = values;
      localStorage.setItem("nav", JSON.stringify(values));
      this.navigationChanged.updateNav.emit(values);
    });
  }

  ngOnInit() {
    this.setup();
    this.currentUser = this.loginService.getCurrentUser();
    this.ready = true;
  }

  setup() {
    console.log("Running Setup");
    this.userName = localStorage.getItem("name");
    this.userPicture = localStorage.getItem("picture");
    this.navData = JSON.parse(localStorage.getItem("nav"));
  }

  // Calling signOut() in the login service and allowing the security to navigate the user back to the login page
  logout() {
    if (google != null) {
      google.accounts.id.disableAutoSelect();
    }
    this.loginService.signOut();
  }
}
